export class BrowserStorage {
  /**
   * @param {Storage} storage
   */
  constructor(storage) {
    this._storage = storage;
  }

  /**
   * @param {string} key
   * @returns {string | null}
   */
  get(key) {
    return this._storage.getItem(key);
  }

  /**
   * @param {string} key
   * @param {string} value
   */
  set(key, value) {
    this._storage.setItem(key, value);
  }

  /**
   * @param {string} key
   */
  remove(key) {
    this._storage.removeItem(key);
  }

  clear() {
    this._storage.clear();
  }
}
function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
export const localStorage = new BrowserStorage(window.localStorage);
export const setAccessToken = (accessToken) =>
  localStorage.set("ACCESS_TOKEN", accessToken);
export const setLastPopupAlert = (time) =>
  localStorage.set("POPUP_ALERT", time);
export const setConfiguration = (config) =>
  localStorage.set("CONFIGURATION", config);
export const getAccessToken = () => localStorage.get("ACCESS_TOKEN");
export const getLastPopupAlert = () => localStorage.get("POPUP_ALERT");
export const getConfiguration = () => {
  const config = localStorage.get("CONFIGURATION");
  if (isJsonString(config)) return JSON.parse(config);
  return null;
};

export const clearAccessToken = () => localStorage.remove("ACCESS_TOKEN");
export const setUserRole = (userRole) =>
  localStorage.set("USER_ROLE", userRole);
export const getUserRole = () => localStorage.get("USER_ROLE");
export const clearUserRole = () => localStorage.remove("USER_ROLE");


export const setApp = (app) =>
  localStorage.set("SELECTED_APP", app);
export const getApp = () => localStorage.get("SELECTED_APP");